import type { UpdatePackRequest } from 'app/typings/core/admin/packs/packForm';
import {
  getRejectedFields,
  makeTabFieldErrorHelpers,
} from 'app/utils/tabFieldErrors';

import { MenuItemName } from './menuItem';

type PackFormOnlyField =
  | 'aliasForHotel'
  | 'aliasForUser'
  | 'channelManageRateCode'
  | 'maxBookingConfiguration'
  | 'hotelId'
  | 'isDaytime'
  | 'slug'
  | 'launchTime';

type PackFormField = keyof UpdatePackRequest | PackFormOnlyField;

export const PACK_TAB_FIELDS = {
  [MenuItemName.General]: [
    'nameForHotel',
    'aliasForHotel',
    'nameForUser',
    'aliasForUser',
    'channelManagerRateCode',
    'channelManageRateCode',
    'openingHours',
    'isGem',
    'launchDate',
    'launchTime',
    'oldPackId',
    'ownerId',
    'hotelId',
    'isDaytime',
    'slug',
  ],
  [MenuItemName.ExperiencesAndRooms]: [
    'packRooms',
    'packExperiences',
    'experiences',
  ],
  [MenuItemName.Limitations]: [
    'minChargedPax',
    'maxAllowedPax',
    'maxAllowedAdult',
    'maxAllowedChild',
    'maxBookingConfiguration',
  ],
  [MenuItemName.Copywriting]: ['description', 'customTagIds'],
  [MenuItemName.Disclaimer]: ['disclaimers'],
  [MenuItemName.Medias]: [
    'horizontalCoverPicture',
    'verticalCoverPicture',
    'introPictures',
    'packExperiences',
  ],
} as const satisfies Record<MenuItemName, readonly PackFormField[]>;

type MappedPackField = (typeof PACK_TAB_FIELDS)[MenuItemName][number];
type UnmappedPackField = Exclude<PackFormField, MappedPackField>;

export const everyPackFieldIsMapped: [UnmappedPackField] extends [never]
  ? true
  : UnmappedPackField = true;

export const { activeTabHasFieldError, getFirstActiveTabErrorField } =
  makeTabFieldErrorHelpers<MenuItemName>(PACK_TAB_FIELDS);

export { getRejectedFields };
